const variable = {
  primaryColor: '#2559E4',
  c2dArrowColor: '#FF8800',
  addMeetingBtnColor: '#FF8800',
  addMeetingBtnTextColor: '#FFFFFF',
};

export default variable;
